import VFG from 'vue3-form-generator'
import 'vue3-form-generator/dist/style.css'

// The Vue 3 fork groups validation errors by the optional fieldName property.
// Existing schemas identify fields by object identity and don't set fieldName,
// which otherwise causes every error to be rendered below every field.
const formGenerator = VFG.component
const formGroup = formGenerator.components.formGroup

formGroup.methods.fieldErrors = function (field) {
  return this.errors
    .filter(error => error.field === field)
    .map(error => error.error)
}

formGenerator.methods.onFieldValidated = function (isValid, errors, field) {
  this.errors = this.errors.filter(error => error.field !== field.schema)
  if (!isValid && errors && errors.length > 0) {
    errors.forEach(error => {
      this.errors.push({
        field: field.schema,
        error
      })
    })
  }
  this.$emit('validated', this.errors.length === 0, this.errors, this)
}

// vue3-form-generator spreads abstractField onto the default export (not a named export).
export const abstractField = {
  name: 'abstractField',
  props: VFG.props,
  data: VFG.data,
  directives: VFG.directives,
  computed: VFG.computed,
  methods: VFG.methods
}

export const validators = VFG.validators

export default VFG
